export const defaultFees = [
    { category: 'daily-rate', unit: 'day', title: 'Tagessatz', currency: 'EUR', icon: 'far fa-calendar-days fa-fw', tiered: false, account: '', rates: [{rate: 0, absence: []}] },
    { category: 'monthly-rate', unit: 'month', title: 'Monatssatz', currency: 'EUR', icon: 'far fa-calendar-day fa-fw', tiered: false, account: '', rates: [{rate: 0}] },
    {
        category: 'fls', unit: 'hour', title: 'Fachleistungsstunden', currency: 'EUR', icon: 'far fa-house-medical fa-fw', rates: [
            {rate: 0, states: { 'failed_attempt': {type: false}, 'cancelled_early' : {type: false}, 'cancelled_late': {type: false}}}
        ], account: ''
    },
    {
        category: 'qa', unit: 'hour', title: 'Qualifizierte Assistenz', currency: 'EUR', icon: 'far fa-alarm-plus fa-fw', account: '', rates: [
            {rate: 0, states: { 'failed_attempt': {type: false}, 'cancelled_early' : {type: false}, 'cancelled_late': {type: false}}}
        ]
    },
    {
        category: 'ca', unit: 'hour', title: 'Kompensatorische Assistenz', currency: 'EUR', icon: 'far fa-alarm-clock fa-fw', account: '', rates: [
            {rate: 0, states: { 'failed_attempt': {type: false}, 'cancelled_early' : {type: false}, 'cancelled_late': {type: false}}}
        ]
    },
    {
        category: 'edu', unit: 'hour', title: 'Schulbegleitung', currency: 'EUR', icon: 'far fa-graduation-cap fa-fw', account: '', rates: [
            {rate: 0, states: { 'failed_attempt': {type: false}, 'cancelled_early' : {type: false}, 'cancelled_late': {type: false}}}
        ]
    },
    // {
    //     category: 'mla', unit: 'hour', title: 'Muttersprachliche Assistenz', currency: 'EUR', icon: 'far fa-comment-lines fa-fw', account: '', rates: [
    //         {rate: 0, states: { 'failed_attempt': {type: false}, 'cancelled_early' : {type: false}, 'cancelled_late': {type: false}}}
    //     ]
    // },
    // {
    //     category: 'cga', unit: 'hour', title: 'Betreuungshilfe', currency: 'EUR', icon: 'far fa-hand-heart fa-fw', account: '', rates: [
    //         {rate: 0, states: { 'failed_attempt': {type: false}, 'cancelled_early' : {type: false}, 'cancelled_late': {type: false}}}
    //     ]
    // },
    // {
    //     category: 'dca', unit: 'hour', title: 'Kita-Assistenz', currency: 'EUR', icon: 'far fa-child fa-fw', account: '', rates: [
    //         {rate: 0, states: { 'failed_attempt': {type: false}, 'cancelled_early' : {type: false}, 'cancelled_late': {type: false}}}
    //     ]
    // },
    // { category: 'hourly-rate', unit: 'hour', title: 'Tagessatz', rate: 0, currency: 'EUR' },
    { category: 'rent', unit: 'month', title: 'Miete', currency: 'EUR', icon: 'far fa-house fa-fw', account: '', rates: [{rate: 0}] },
    { category: 'rent-utilities', unit: 'month', title: 'Miete Nebenkosten', currency: 'EUR', icon: 'far fa-faucet fa-fw', account: '', rates: [{rate: 0}] },
    { category: 'way', unit: 'km'/*['km', 'hour']*/, title: 'Fahrten', currency: 'EUR', icon: 'far fa-car fa-fw', account: '', rates: [{rate: 0}] },
    { category: 'allowance', unit: 'day', title: 'Taschengeld', currency: 'EUR', icon: 'far fa-money-bill-1 fa-fw', tiered: true, account: '', rates: [{tiers: [{age: 5, rate: 0}]}] },
    { category: 'clothing', unit: 'day', title: 'Bekleidungsgeld', currency: 'EUR', icon: 'far fa-shirt fa-fw', tiered: true, account: '', rates: [{tiers: [{age: 5, rate: 0}]}] },
    { category: 'food', unit: 'day', title: 'Essenspauschale', currency: 'EUR', icon: 'far fa-utensils fa-fw', account: '', rates: [{rate: 0}] },
    // { category: 'furniture', unit: 'once', title: 'Wohnen Erstausstattung', currency: 'EUR', icon: 'far fa-couch fa-fw', tiered: false, rates: [{rate: 0}] },
    // { category: 'custom', unit: 'once'/*['once', 'hour', 'day', 'month']*/, title: '', currency: 'EUR', icon: 'far fa-badge fa-fw', tiered: false, rates: [{rate: 0}] },
]


export const defaultCashbookCategories = [
    {value: 'allowance', text: 'Taschengeld', icon: 'fa-money-bill-1'},
    {value: 'clothing', text: 'Bekleidungsgeld', icon: 'fa-shirt'},
    {value: 'ticket', text: 'Fahrkarte', icon: 'fa-ticket'},
    {value: 'pass', text: 'Eintrittskarte', icon: 'fa-ticket'},
    {value: 'birthday-gift', text: 'Geburtstagsgeschenk', icon: 'fa-birthday-cake'},
    {value: 'christmas-gift', text: 'Weihnachtsgeschenk', icon: 'fa-christmas-tree'},
    {value: 'furniture', text: 'Wohnen / Einrichtung', icon: 'fa-couch'},
    {value: 'school-supplies', text: 'Schulausstattung', icon: 'fa-education'},
    {value: 'other', text: 'Sonstiges', icon: 'fa-question'},
]


export const germanFederalStates = {
    "BW": 'Baden-Württemberg', 
    "BY": 'Bayern', 
    "BE": 'Berlin', 
    "BB": 'Brandenburg', 
    "HB": 'Bremen', 
    "HH": 'Hamburg', 
    "HE": 'Hessen', 
    "MV": 'Mecklenburg-Vorpommern', 
    "NI": 'Niedersachsen', 
    "NW": 'Nordrhein-Westfalen', 
    "RP": 'Rheinland-Pfalz', 
    "SL": 'Saarland',
    "SN": 'Sachsen', 
    "ST": 'Sachsen-Anhalt', 
    "SH": 'Schleswig-Holstein', 
    "TH": 'Thüringen'
}